import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { CapacitiesTable } from 'Features/Projects/Scenarios/EditSettings/FactorySettings/Capacities.Table'
import { useBaseSourceSiteWorkCentre } from '../EditSettings.data'
import { EditSettingsDataFilter } from '../EditSettings.DataFilter'
import { useMemo } from 'react'

export const CapacitiesView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId, selectedBaseSourceSite, selectedWorkCentre } =
    state
  const { data: baseSourceSiteWorkCentre, isLoading } =
    useBaseSourceSiteWorkCentre({
      projectId,
      scenarioId,
    })

  const filteredCapacitiesData = useMemo(() => {
    if (!baseSourceSiteWorkCentre) return []

    let filtered = baseSourceSiteWorkCentre

    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }

    // Filter by workCentre
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workcentreCode === selectedWorkCentre
      )
    }

    return filtered
  }, [baseSourceSiteWorkCentre, selectedBaseSourceSite, selectedWorkCentre])

  return (
    <SettingsPage title="Capacities" actions={<EditSettingsDataFilter />}>
      <CapacitiesTable data={filteredCapacitiesData} isLoading={isLoading} />
    </SettingsPage>
  )
}
